import { BaseConfig } from "../config.interface";

interface IInputSwitchConfig {
    label?: string;
}
export class InputSwitchConfig extends BaseConfig<IInputSwitchConfig> implements IInputSwitchConfig {
    /**
     * Label of the element.
     */
    label?: string;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new InputSwitchConfig({}),
        Active:  new InputSwitchConfig({
            label: "Aktiv"
        }),
    };
}
